module.exports = __webpack_public_path__ + "static/media/my-koin.a45dd919.svg";